import { GlobalSearchData } from './globalSearch.utils';
import { Dispatch, SetStateAction } from 'react';

export enum SearchResultType {
  PROJECT = 'project',
  ASSET = 'asset',
  BOOKED_ASSET = 'booked_asset',
}

export type SearchResultItemData = {
  title: string;
  description: string;
  link: string;
  externalIdentifier: string;
  type: SearchResultType;
};

export type SearchResultHeaderProps = {
  title: string;
};

export type SearchResultItemProps = SearchResultItemData & {
  closeDrawer: () => void;
  setRecentSearches: Dispatch<SetStateAction<SearchResultItemData[]>>;
  isOnline?: boolean;
};

export type SearchResultProps = {
  isFetching: boolean;
  searchString: string;
  data: GlobalSearchData;
  handleClose: () => void;
};

export type SearchDrawerProps = {
  isSearchDrawerOpen: boolean;
  setIsSearchDrawerOpen: Dispatch<SetStateAction<boolean>>;
};
